import Vue from 'vue'
import clone from 'clone'
import { QUOTE_TRAVEL_PARAM, QUOTE_TRAVEL_PARAM_GENERAL, QUOTE_TRAVEL_GENERAL, QUOTE_TRAVEL_PLANS, QUOTE_TRAVEL_PARAM_PLAN_LOADING, QUOTE_TRAVEL_PARAM_PLAN_SUCCESS, QUOTE_TRAVEL_PARAM_PLAN_FAIL, QUOTE_TRAVEL_APPLICANT, QUOTE_TRAVEL_INSURED_ADD, QUOTE_TRAVEL_INSURED_REMOVE, QUOTE_TRAVEL_INSURED_UPDATE, QUOTE_TRAVEL_PAYMENT, QUOTE_TRAVEL_ADJ_CANCEL, QUOTE_TRAVEL_RECALCULATE_LOADING, QUOTE_TRAVEL_RECALCULATE_SUCCESS, QUOTE_TRAVEL_RECALCULATE_FAIL } from '@/store/types'
import { commitPkgPremium } from './quote'
import { formatServerTimeFormat } from '@/utils/date'

export const travel = {
  [QUOTE_TRAVEL_PARAM](state, data) {
    // Note: Key - ignoreValue is reserved
    if (data) {
      const formatData = data
      let ignoreValue = data.ignoreValue
      if (ignoreValue === undefined) {
        ignoreValue = false
      }
      Object.keys(formatData).forEach(function (key) {
        if (key !== 'ignoreValue') {
          const arr = formatData[key]
          if (arr) {
            if (Array.isArray(arr)) {
              // Make it so that its value - label (easier to search)
              arr.map(obj => {
                if (!ignoreValue) {
                  obj.label = obj.value + ' - ' + obj.label
                }
              })
            }
            // Initially was using the Object.assign below
            // But due to vue js reactive caveats, we will use Vue.set instead
            Vue.set(state.quotation.travelParam, key, arr)
          }
        }
      })
    }
  },
  [QUOTE_TRAVEL_PARAM_GENERAL](state) {
    state.quotation.travelParam.generalLoaded = true
  },
  [QUOTE_TRAVEL_GENERAL](state, data) {
    if (data) {
      state.quotation.commonForm.product = data.product
      state.quotation.commonForm.acceptDate = data.acceptDate
      state.quotation.commonForm.startDate = data.startDate
      state.quotation.commonForm.endDate = data.endDate
      state.quotation.commonForm.campaign = data.campaign
      state.quotation.commonForm.promotion = data.promotion
      Vue.set(state.quotation.commonForm, 'discLdg', clone(data.discLdg))

      state.quotation.travelForm.tripType = data.tripType
      state.quotation.travelForm.travelArea = data.travelArea
      state.quotation.travelForm.noAdult = data.noAdult
      state.quotation.travelForm.noChild = data.noChild

      // Reset plans init (always get new plans after 1st screen)
      state.quotation.travelParam.plans.init = 0
    }
  },
  [QUOTE_TRAVEL_PARAM_PLAN_LOADING](state) {
    state.quotation.travelParam.plans.init = 0
    state.quotation.travelParam.plans.initErr = []
    state.quotation.travelParam.plans.limitsText = []
    state.quotation.travelParam.plans.plans = []
  },
  [QUOTE_TRAVEL_PARAM_PLAN_SUCCESS](state, data) {
    state.quotation.travelParam.plans.limitsText = data.limitsText
    state.quotation.travelParam.plans.plans = data.plans
    state.quotation.travelParam.plans.init = 1
    state.quotation.travelParam.plans.initErr = []
  },
  [QUOTE_TRAVEL_PARAM_PLAN_FAIL](state, data) {
    state.quotation.travelParam.plans.init = 2
    state.quotation.travelParam.plans.limitsText = []
    state.quotation.travelParam.plans.plans = []
    state.quotation.travelParam.plans.initErr = []
    if (data && data.length > 0) {
      state.quotation.travelParam.plans.initErr = data
    }
  },
  [QUOTE_TRAVEL_PLANS](state, data) {
    if (data) {
      state.quotation.travelForm.planNo = data.planNo
      state.quotation.travelForm.travelType = data.travelType

      // Save premium info to commonInfo
      const plan = state.quotation.travelParam.plans.plans.find(x => x.planNo === data.planNo && x.subPlan === data.travelType)
      if (plan && plan.premium) {
        commitPkgPremium(state, plan.premium)

        // Flag reviewPlan init as 1 (as it wont trigger recalculate when coming back from the next page)
        state.quotation.travelParam.reviewPlan.init = 1
      } else {
        commitPkgPremium(state, null)
      }
    } else {
      state.quotation.travelForm.planNo = null
      state.quotation.travelForm.travelType = null
      commitPkgPremium(state, null)
    }
  },
  [QUOTE_TRAVEL_APPLICANT](state, data) {
    if (data) {
      // Applicant Information
      const { applicant } = state.quotation.commonForm

      applicant.appIntStat = data.appIntStat
      applicant.appSalutation = data.appSalutation
      applicant.appName = data.appName
      applicant.appNricPassport = data.appNricPassport
      if (data.appDob) {
        applicant.appDob = formatServerTimeFormat(data.appDob)
      }
      applicant.appGender = data.appGender
      applicant.appIsStudent = data.appIsStudent
      applicant.appIsInsured = data.appIsInsured
      applicant.appEmail = data.appEmail
      applicant.appMobileNo = data.appMobileNo
      applicant.appTelNo1 = data.appTelNo1
      applicant.appTelNo2 = data.appTelNo2
      applicant.appPostalCode = data.appPostalCode
      applicant.appAdd1 = data.appAdd1
      applicant.appAdd2 = data.appAdd2
      applicant.appAdd3 = data.appAdd3
      applicant.appAdd4 = data.appAdd4
      applicant.mailAdd = data.mailAdd
      applicant.mailPostalCode = data.mailPostalCode
      applicant.mailAdd1 = data.mailAdd1
      applicant.mailAdd2 = data.mailAdd2
      applicant.mailAdd3 = data.mailAdd3
      applicant.mailAdd4 = data.mailAdd4
      applicant.coyName = data.coyName
      applicant.coyRocUen = data.coyRocUen
      applicant.coyNature = data.coyNature

      const { travelForm } = state.quotation
      // Remove applicant if it exist in insureds
      const mainInsured = travelForm.insureds.find(x => x.isApplicant === true)
      if (mainInsured) {
        travelForm.insureds.splice(travelForm.insureds.indexOf(mainInsured), 1)
      }
      if (data.appIsInsured) {
        // Clone applicant to insured (if it has full data)
        if (data.appName && data.appNricPassport && data.appDob && data.appGender) {
          travelForm.insureds.unshift({
            name: data.appName,
            nricPassport: data.appNricPassport,
            dob: applicant.appDob,
            relationship: null,
            gender: data.appGender,
            isStudent: data.appIsStudent,
            isApplicant: true
          })
        }
      }
    }
  },
  [QUOTE_TRAVEL_INSURED_ADD](state, data) {
    if (data) {
      const cloneInsured = clone(data)
      if (cloneInsured.dob) {
        cloneInsured.dob = formatServerTimeFormat(cloneInsured.dob)
      }
      state.quotation.travelForm.insureds.push(cloneInsured)
    }
  },
  [QUOTE_TRAVEL_INSURED_REMOVE](state, index) {
    state.quotation.travelForm.insureds.splice(index, 1)
  },
  [QUOTE_TRAVEL_INSURED_UPDATE](state, data) {
    if (data) {
      const { index, insured } = data
      Vue.set(state.quotation.travelForm.insureds, index, clone(insured))
    }
  },
  [QUOTE_TRAVEL_PAYMENT](state, data) {
    state.quotation.commonForm.paytMode = data.paytMode
    state.quotation.commonForm.paytCCNo = data.paytCCNo
    state.quotation.commonForm.paytCCName = data.paytCCName
    state.quotation.commonForm.paytCCType = data.paytCCType
    state.quotation.commonForm.paytCCExpMth = data.paytCCExpMth
    state.quotation.commonForm.paytCCExpYr = data.paytCCExpYr
    state.quotation.commonForm.paytCCCvv = data.paytCCCvv
  },
  [QUOTE_TRAVEL_ADJ_CANCEL](state) {
    // Reset Plan
    state.quotation.travelForm.planNo = null

    // Reset Adjustment
    state.quotation.commonForm.adjDiscount = null

    // Reset Premium
    commitPkgPremium(state, null)
  },
  [QUOTE_TRAVEL_RECALCULATE_LOADING](state) {
    state.quotation.travelParam.reviewPlan.init = 0
    state.quotation.travelParam.reviewPlan.initErr = []
  },
  [QUOTE_TRAVEL_RECALCULATE_SUCCESS](state, data) {
    state.quotation.travelParam.reviewPlan.init = 1
    state.quotation.travelParam.reviewPlan.initErr = []
    commitPkgPremium(state, data)
  },
  [QUOTE_TRAVEL_RECALCULATE_FAIL](state, data) {
    state.quotation.travelParam.reviewPlan.init = 2
    if (data && data.length > 0) {
      state.quotation.travelParam.reviewPlan.initErr = data
    }
    // Reset Premium
    commitPkgPremium(state, null)
  }
}
